<div class="page-size-selector-container">
    <div></div>
    <div class="page-size-selector-container-right justify-content-end">
        <div class="select-show">
            Mostrar
            <select class="select-input" (change)="onChange($event.target.value)">
                <option *ngFor="let val of sizePageSteps" [value]="val">{{val}}</option>
            </select>
            por página
        </div>
    </div>
</div>


